<template>
    <div>
        <b-modal
            id="add-data-segment-popup"
            ref="modal"
            :title="title"
            size="lg"
            hide-footer
            no-close-on-backdrop
            modal-class="hide-footer"
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-5"
                            label="Country"
                            label-for="country"
                        >
                            <b-form-select
                                v-model="formData.nationality"
                                v-validate="{
                                    required: true,
                                }"
                                name="country"
                                :class="[
                                    'form-control',
                                    {
                                        'is-invalid': errors.has('country'),
                                    },
                                ]"
                                :options="nationalities"
                                disabled
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-1"
                            label="Data Segment Title"
                            label-for="segment-title"
                        >
                            <b-form-input
                                id="segment-title"
                                v-model="formData.title"
                                v-validate="{
                                    required: true,
                                    max: 50,
                                    min: 5,
                                }"
                                type="text"
                                name="title"
                                :class="{
                                    'is-invalid': errors.has('title'),
                                }"
                                autocomplete="no"
                                placeholder="Enter data segment title"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Tier"
                            label-for="Tier"
                            :class="{
                                'required-field': tierField.isRequired,
                            }"
                        >
                            <b-form-input
                                id="tier"
                                v-model="formData.tier"
                                v-validate="'between:0,100000'"
                                type="number"
                                name="tier"
                                :class="{
                                    'is-invalid': errors.has('tier'),
                                }"
                                autocomplete="no"
                                placeholder="Enter Tier"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="idv_count"
                            label="Allowed Profile(s)"
                            label-for="idv_count"
                        >
                            <b-form-input
                                id="idv_count"
                                v-model="formData.idv_count"
                                v-validate="{
                                    required: true,
                                }"
                                type="text"
                                name="Allowed Profile(s)"
                                :class="{
                                    'is-invalid': errors.has('title'),
                                }"
                                autocomplete="no"
                                placeholder="Enter Profile count"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="idv_remaining_count"
                            label="Remaining Profile(s)"
                            label-for="idv_remaining_count"
                        >
                            <b-form-input
                                id="idv_remaining_count"
                                v-model="formData.idv_remaining_count"
                                v-validate="{
                                    required: true,
                                }"
                                type="text"
                                name="idv_remaining_count"
                                :class="{
                                    'is-invalid': errors.has('title'),
                                }"
                                autocomplete="no"
                               
                                disabled
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group
                            id="counter"
                            label="Counter"
                            label-for="counter"
                        >
                            <b-form-input
                                id="counter"
                                v-model="formData.counter"
                                v-validate="{
                                    required: true,
                                }"
                                type="text"
                                name="counter"
                                :class="{
                                    'is-invalid': errors.has('counter'),
                                }"
                                autocomplete="no"
                                placeholder="Enter Counter"
                                disabled
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-6"
                            label="Free / Paid"
                            label-for="freePaid"
                        >
                            <b-form-select
                                v-model="formData.subscription"
                                v-validate="{
                                    required: true,
                                }"
                                name="freePaid"
                                :class="[
                                    'form-control',
                                    {
                                        'is-invalid': errors.has('freePaid'),
                                    },
                                ]"
                                :options="freePaidOptions"
                                disabled
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-6"
                            label="Live/Test"
                            label-for="liveTest"
                        >
                            <b-form-select
                                v-model="formData.accountUse"
                                v-validate="{
                                    required: true,
                                }"
                                name="liveTest"
                                :class="[
                                    'form-control',
                                    {
                                        'is-invalid': errors.has('liveTest'),
                                    },
                                ]"
                                :options="liveTestOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-6"
                            label="From Email (for automated emails)"
                            label-for="fromEmail"
                        >
                            <b-form-input
                                v-model="formData.fromEmail"
                                v-validate="{
                                    email: true,
                                }"
                                name="fromEmail"
                                :class="[
                                    'form-control',
                                    {
                                        'is-invalid': errors.has('fromEmail'),
                                    },
                                ]"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <!-- <div class="col-md-6">
                        <b-form-group
                            id="input-group-6"
                            label="Standard/Lite"
                            label-for="accountType"
                        >
                            <b-form-select
                                v-model="formData.accountType"
                                v-validate="{
                                    required: true,
                                }"
                                name="accountType"
                                :class="[
                                    'form-control',
                                    {
                                        'is-invalid': errors.has('accountType'),
                                    },
                                ]"
                                :options="accountTypeOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div> -->
                    <div class="col-md-6">
                        <b-form-group
                            id="whiteLabelling"
                            label="White Labelling ?"
                            label-for="whiteLabelling"
                        >
                            <b-form-radio-group
                                v-model="formData.whiteLabelling"
                                autocomplete="no"
                                :disabled="loading"
                                :options="radioOptions"
                                :text-field="textField"
                                :value-field="valueField"
                                data-vv-name="whiteLabelling"
                                :class="{
                                    'is-invalid': errors.has('whiteLabelling'),
                                }"
                            >
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="kyb"
                            label="Allow KYB"
                            label-for="kyb"
                        >
                            <b-form-radio-group
                                v-model="formData.kyb"
                                autocomplete="no"
                                :disabled="loading"
                                :options="radioOptions"
                                :text-field="textField"
                                :value-field="valueField"
                                data-vv-name="KYB"
                                :class="{
                                    'is-invalid': errors.has('KYB'),
                                }"
                            >
                                <!-- <option slot="first" :value="null" disabled>
                                    {{ onboardingType.placeholder }}
                                </option> -->
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="rescreenAdvMedia"
                            label="Allow Adverse Media Rescreening"
                            label-for="rescreenAdvMedia"
                        >
                            <b-form-radio-group
                                v-model="formData.rescreenAdvMedia"
                                autocomplete="no"
                                :disabled="loading"
                                :options="radioOptions"
                                :text-field="textField"
                                :value-field="valueField"
                                data-vv-name="Adverse Media Rescreening"
                                :class="{
                                    'is-invalid': errors.has(
                                        'Adverse Media Rescreening'
                                    ),
                                }"
                            >
                                <!-- <option slot="first" :value="null" disabled>
                                    {{ onboardingType.placeholder }}
                                </option> -->
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="idv"
                            label="Allow idv sdk"
                            label-for="idv"
                        >
                            <b-form-radio-group
                                v-model="formData.idv"
                                autocomplete="no"
                                :disabled="loading"
                                :options="radioOptions"
                                :text-field="textField"
                                :value-field="valueField"
                                data-vv-name="IDV"
                                :class="{
                                    'is-invalid': errors.has('IDV'),
                                }"
                            >
                                <!-- <option slot="first" :value="null" disabled>
                                {{ onboardingType.placeholder }}
                            </option> -->
                            </b-form-radio-group>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group
                            id="next-review"
                            label="next review date"
                            label-for="next-review-date"
                        >
                            <b-form-radio-group
                                v-model="formData.nextReview.status"
                                type="text"
                                autocomplete="no"
                                :disabled="loading"
                                :options="nextReview.options"
                                :text-field="textField"
                                :value-field="valueField"
                                :data-vv-name="nextReview.label"
                                :class="{
                                    'is-invalid': errors.has(nextReview.label),
                                }"
                            >
                                <!-- <option slot="first" :value="null" disabled>
                                    {{ onboardingType.placeholder }}
                                </option> -->
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                    <!-- idv configuration work-->
                    <div v-if="formData.idv" class="col-md-12">
                        <idvConfig :ds="formData.id"></idvConfig>
                    </div>

                    <!-- end of idv configuration work-->
                    <div class="col-md-6">
                        <b-form-group
                            id="smart-screen"
                            label="smart screen"
                            label-for="smart-screen"
                        >
                            <b-form-radio-group
                                v-model="formData.smartScreen"
                                type="text"
                                autocomplete="no"
                                :disabled="loading"
                                :options="smartScreen.options"
                                :text-field="textField"
                                :value-field="valueField"
                                :data-vv-name="smartScreen.label"
                                :class="{
                                    'is-invalid': errors.has(smartScreen.label),
                                }"
                            >
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <h5 class="m-b-30">
                            Enable UAE-Specific Profile Fields
                        </h5>
                        <b-form-group
                            id="uaepassfield"
                            label="Choose whether to include UAE-specific fields in the onboarding form for UAE customers."
                            label-for="uaepassfield"
                        >
                            <b-form-radio-group
                                v-model="formData.uaepassfield"
                                type="text"
                                autocomplete="no"
                                :disabled="loading"
                                :options="radioOptions"
                                :text-field="textField"
                                :value-field="valueField"
                            >
                                <!-- <option slot="first" :value="null" disabled>
                                {{ onboardingType.placeholder }}
                            </option> -->
                            </b-form-radio-group>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group
                            v-if="formData.nextReview.status"
                            label="Duration"
                            label-for="Duration"
                            :class="{
                                'required-field': true,
                            }"
                        >
                            <b-form-input
                                id="next-review-duration"
                                v-model="formData.nextReview.duration"
                                v-validate="'required|between:0.1,10'"
                                type="number"
                                step="0.1"
                                name="duration"
                                :class="{
                                    'is-invalid': errors.has('duration'),
                                }"
                                autocomplete="no"
                                placeholder="Enter Duration in Years"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col-md-10">
                        <label
                            class="m-b-15 ml-2"
                            style="font-size: 14px !important"
                        >
                            Subscription Details</label
                        >
                    </div>
                    <div class="col-md-2">
                        <span
                            class="addMoreIcon"
                            title="Add More"
                            @click="addOption"
                            >+</span
                        >
                    </div>
                    <div class="col-md-12">
                        <hr />
                    </div>

                    <div class="scrollable more-fields-popup">
                        <div
                            v-for="(list, index) in formData.packageDetails"
                            :key="index"
                            class="row mt-2"
                            style="
                                box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
                                background-color: #f0f0f0;
                            "
                        >
                            <div
                                
                                class="col-xs-12 col-md-12"
                            >
                                <span
                                    v-if="list.stripeTransaction"
                                    class="removed-row-class"
                                    >
                                    <img src="/img/icons/stripe-logo.gif" width="60" />
                                    </span>
                                <span
                                   v-else-if="formData.packageDetails.length > 1"
                                    class="removed-row-class"
                                    @click.prevent="deleteRow(index)"
                                    ><i class="icon-delete"></i
                                ></span>
                            </div>

                            <div class="col-md-6 mt-2">
                                <b-form-group
                                    id="input-group-1"
                                    label="Subscription Date"
                                    label-for="sub-date"
                                >
                                    <!--<b-form-input-->
                                    <!--:id="'option' + index"-->
                                    <!--v-model="list.subscriptionDate"-->
                                    <!--type="date"-->
                                    <!--:name="'subscriptionDate' + index"-->
                                    <!--:class="{-->
                                    <!--'is-invalid':-->
                                    <!--errors.has('subscriptionDate'),-->
                                    <!--}"-->
                                    <!--autocomplete="no"-->
                                    <!--placeholder="Enter Subscription Date"-->
                                    <!--@input="handleDateInput"-->

                                    <!--&gt;</b-form-input>-->
                                    <div class="form-group custom-datepicker">
                                        <date-picker
                                            ref="start date"
                                            v-model="list.subscriptionDate"
                                            class="form-control"
                                            name="Subscription Date"
                                            format="DD/MM/YYYY"
                                            lang="en"
                                            :class="{
                                                'is-invalid':
                                                    errors.has('start date'),
                                            }"
                                        ></date-picker>

                                        <i
                                            :class="[
                                                { 'disable-input': false },
                                                'icon-calendar',
                                            ]"
                                        ></i>
                                    </div>
                                </b-form-group>
                            </div>
                            <div class="col-md-6 mt-2">
                                <b-form-group
                                    id="primary"
                                    label="Primary Subscription"
                                    label-for="primary"
                                >
                                    <b-form-radio-group
                                        v-model="list.isPrimary"
                                        autocomplete="no"
                                        :disabled="loading"
                                        :options="radioOptions"
                                        :text-field="textField"
                                        :value-field="valueField"
                                        data-vv-name="Primary Subscription"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'Primary Subscription'
                                            ),
                                        }"
                                    >
                                    </b-form-radio-group>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-1"
                                    label="Deal Type"
                                    label-for="deal-type"
                                >
                                    <!-- <b-form-select  v-if="list.isPrimary"
                                            v-model="list.dealType"
                                            type="text"
                                            autocomplete="no"
                                            :disabled="loading"
                                            :options="dealTypeField.options"
                                            :text-field="textField"
                                            :value-field="valueField"
                                            :data-vv-name="dealTypeField.label"
                                            class="form-control custom-select"
                                            :class="{
                                    'is-invalid': errors.has(
                                        dealTypeField.label
                                    ),
                                }"
                                    >
                                        <option
                                            slot="first"
                                            :value="null"
                                            disabled
                                        >
                                            {{ dealTypeField.placeholder }}
                                        </option>
                                    </b-form-select> -->
                                    <b-form-input
                                            :disabled="true"
                                            :value="list.isPrimary ? 'Annual' : 'Pro Rata'"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-1"
                                    label="Payment Method"
                                    label-for="pay-method"
                                >
                                    <b-form-select
                                        v-model="list.paymentMethod"
                                        type="text"
                                        autocomplete="no"
                                        :disabled="loading"
                                        :options="paymentMethodField.options"
                                        :text-field="textField"
                                        :value-field="valueField"
                                        :data-vv-name="paymentMethodField.label"
                                        class="form-control custom-select"
                                        :class="{
                                            'is-invalid': errors.has(
                                                paymentMethodField.label
                                            ),
                                        }"
                                    >
                                        <option
                                            slot="first"
                                            :value="null"
                                            disabled
                                        >
                                            {{ paymentMethodField.placeholder }}
                                        </option>
                                    </b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-1"
                                    label="Sales Lead"
                                    label-for="sales-lead"
                                >
                                    <b-form-input
                                        :id="'option' + index"
                                        v-model="list.salesLead"
                                        v-validate="{
                                            max: 50,
                                            min: 5,
                                        }"
                                        type="text"
                                        :name="'salesLead' + index"
                                        :class="{
                                            'is-invalid':
                                                errors.has('salesLead'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter Sales Lead"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-1"
                                    label="Additional Profiles"
                                    label-for="sub-month"
                                >
                                    <b-form-input
                                        :id="'option' + index"
                                        v-model="list.additionalProfiles"
                                        type="number"
                                        :name="'additionalProfiles' + index"
                                        :class="{
                                            'is-invalid':
                                                errors.has(
                                                    'additionalProfiles'
                                                ),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter Additional Profiles"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
            <base-toast></base-toast>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import idvConfig from '../../views/configuration/idenfo-engine/IdvConfigurations.vue'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    components: {
        DatePicker,
        idvConfig,
    },
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
            textField: 'text',
            valueField: 'value',
            radioOptions: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            packageDetails: [],
            packageDetails1: {
                // salesLead : null,
                // subscriptionMonth:null,
                // subscriptionDate:null,
                // paymentMethodValue:null,
                // dealType:null,
            },
            dealTypeField: {
                label: 'Deal Type',
                title: 'Deal Type',
                placeholder: 'Select type',
                options: [
                    {
                        value: 'Annual',
                        text: 'Annual',
                    },
                    // {
                    //     value: 'Bi-annual',
                    //     text: 'Bi-annual',
                    // },
                    {
                        value: 'Monthly',
                        text: 'Monthly',
                    },
                    // {
                    //     value: 'Quarterly',
                    //     text: 'Quarterly',
                    // },
                ],
            },
            onboardingType: {
                label: 'Onboarding Type',
                title: 'Onboarding Type',
                placeholder: 'Select type',
                options: [
                    {
                        value: 'individual',
                        text: 'individual',
                    },
                    {
                        value: 'entity',
                        text: 'entity',
                    },
                ],
            },
            nextReview: {
                label: 'next review date',
                title: 'next review date',
                // placeholder: 'Select type',
                options: [
                    {
                        value: true,
                        text: 'Yes',
                    },
                    {
                        value: false,
                        text: 'No',
                    },
                ],
            },
            paymentMethodField: {
                label: 'Payment Method',
                title: 'Payment Method',
                placeholder: 'Select method',
                options: [
                    {
                        value: 'Bank Transfer',
                        text: 'Bank Transfer',
                    },
                    {
                        value: 'Cash',
                        text: 'Cash',
                    },
                    {
                        value: 'Card',
                        text: 'Card',
                    },
                    {
                        value: 'Cheque',
                        text: 'Cheque',
                    },
                ],
            },
            tierField: {
                isRequired: true,
                // placeholder: 'Select Tier',
                placeholder: 'Select Tier',
                options: [
                    {
                        value: '0',
                        text: 'Free Trial',
                    },
                    {
                        value: '100',
                        text: '100',
                    },
                    {
                        value: '500',
                        text: '500',
                    },
                    {
                        value: '1000',
                        text: '1000',
                    },
                ],
                label: 'Tier',
                title: 'Tier',
            },
            idv_countField: {
                isRequired: true,
                // placeholder: 'Select Tier',
                placeholder: 'Select idv count',
                options: [
                    {
                        value: '0',
                        text: 'Free Trial',
                    },
                    {
                        value: '100',
                        text: '100',
                    },
                    {
                        value: '500',
                        text: '500',
                    },
                    {
                        value: '1000',
                        text: '1000',
                    },
                ],
                label: 'Idv count',
                title: 'Idv count',
            },
            freePaidOptions: [
                {
                    value: 'trial',
                    text: 'Free',
                },
                {
                    value: 'paid',
                    text: 'Paid',
                },
            ],
            liveTestOptions: [
                {
                    value: 'test',
                    text: 'Test',
                },
                {
                    value: 'live',
                    text: 'Live',
                },
            ],
            accountTypeOptions: [
                {
                    value: 'standard',
                    text: 'Standard',
                },
                {
                    value: 'premium',
                    text: 'Premium',
                },
            ],
            smartScreen: {
                label: 'Smart Screen',
                title: 'Smart Screen',
                // placeholder: 'Select type',
                options: [
                    {
                        value: 'new',
                        text: 'Omniscreen',
                    },
                    {
                        value: 'old',
                        text: 'Smart Search',
                    },
                ],
            },
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'selectedItem',
            'hidePopup',
            'nationalities',
        ]),
        title() {
            return this.selectedItem
                ? 'Modify Data Segment'
                : 'Add Data Segment'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
        emailRequired() {
            return this.formData.emailProfile.status
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */

        'formData.nextReview.status': function (value) {
            if (!value) {
                console.log('Updated duration:')
                this.formData.nextReview.duration = null
            }
        },
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                console.log("smart screen: ", value.smartScreen)
                this.formData.id = value._id
                this.formData.title = value.title
                this.formData.code = value.code
                this.formData.counter = value.counter
                this.formData.tier = value.tier
                this.formData.idv_count = value.idv_count
                this.formData.idv_remaining_count=value.idv_remaining_count
                this.formData.onboardingType = value.onboardingType
                    ? value.onboardingType
                    : null
                this.formData.nextReview.status =
                    value.nextReview && value.nextReview.status
                        ? value.nextReview.status
                        : false
                this.formData.nextReview.duration =
                    value.nextReview && value.nextReview.duration
                        ? value.nextReview.duration
                        : null
                this.formData.kyb = value.kyb ? value.kyb : false
                this.formData.idv = value.idv ? value.idv : false
                this.formData.rescreenAdvMedia = value.rescreenAdvMedia
                    ? value.rescreenAdvMedia
                    : false
                this.formData.subscription =
                    value.accountUse == 'live' ? 'paid' : 'trial'
                this.formData.accountUse = value.accountUse
                this.formData.fromEmail = value.fromEmail
                this.formData.accountType = value.accountType
                this.formData.whiteLabelling = value.whiteLabelling
                this.formData.uaepassfield = value.uaepassfield
                    ? value.uaepassfield
                    : false
                this.formData.smartScreen = value.smartScreen
                    ? value.smartScreen
                    : 'old'
                this.formData.nationality = value.nationality
                    ? value.nationality.title
                    : null
                this.formData.emailProfile = value.emailProfile
                    ? value.emailProfile
                    : {
                          status: false,
                          email: '',
                      }
                if (
                    value.packageDetails &&
                    value.packageDetails.length &&
                    value.packageDetails.length > 0
                ) {
                    this.formData.packageDetails = value.packageDetails
                } else {
                    this.formData.packageDetails = []
                    this.formData.packageDetails.push({
                        salesLead: null,
                        subscriptionDate: null,
                        subscriptionMonth: null,
                        additionalProfiles: null,
                        paymentMethod: null,
                        dealType: null,
                        packageId: null,
                        isPrimary: false,
                    })
                }
            } else if (this.$refs.modal._isShown) {
                this.$refs.modal.hide()
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when popup hides
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
        formData(value) {
            console.log('fd: ', value)
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of mounted
    methods: {
        //initialize form data
        initializeFormData() {
            return {
                id: null,
                title: '',
                code: '',
                nationality: null,
                emailProfile: {
                    email: null,
                    status: false,
                },
                packageDetails: {
                    salesLead: null,
                    additionalProfiles: null,
                    subscriptionMonth: null,
                    subscriptionDate: null,
                    paymentMethod: null,
                    dealType: null,
                    isPrimary: false,
                },
                onboardingType: null,
                nextReview: {
                    status: false,
                    duration: null,
                },
                kyb: false,
                idv: false,
                rescreenAdvMedia: false,
                accountType: 'standard',
                accountUse: 'test',
                fromEmail: '',
                whiteLabelling: false,
                uaepassfield: false,
                smartScreen: 'old',
            }
        },
        addYearToDate(originalDate){
            if(!originalDate) return '';

            const date = new Date(Date.UTC(originalDate.getFullYear() + 1, originalDate.getMonth(), originalDate.getDate()));
            return date.toISOString();
        },
        addMonthToDate(originalDate){
            if(!originalDate) return '';

            const date = new Date(Date.UTC(originalDate.getFullYear(), originalDate.getMonth() + 1, originalDate.getDate()));
            return date.toISOString();
        },

        async onSubmit() {
            const result = await this.$validator.validateAll()
            console.log('Form Data : ' + JSON.stringify(this.formData))
            console.log('Form Data : ' + JSON.stringify(this.formData.smartScreen), typeof this.formData.smartScreen )
            if (result) {
                if(this.formData.packageDetails) {
                    let expiryDate = null;
                    this.formData.packageDetails = this.formData.packageDetails.map(el =>{
                        if(el.subscriptionDate) {
                            if(el.isPrimary) {
                                console.log("raw el.subscriptionDate", el.subscriptionDate);
                            }
                            let date = new Date(el.subscriptionDate)

                            el.subscriptionDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) );
                            // el.subscriptionDate = new Date(el.subscriptionDate);
                            if(el.isPrimary) {
                                console.log("parsed el.subscriptionDate", el.subscriptionDate);
                            }
                        }
                        el.dataSegmentId = this.formData.id
                        if (el.isPrimary) {
                            el.dealType = el.dealType && el.dealType != "Pro Rata" ? el.dealType : "Annual" 
                            expiryDate = el.dealType == "Annual" ? this.addYearToDate(el.subscriptionDate) : this.addMonthToDate(el.subscriptionDate) 
                            console.log("expiryDate", expiryDate)
                        } else {
                            el.dealType = "Pro Rata";
                        }
                        el.expiryDate = expiryDate;
                        el.status = (new Date(expiryDate)).getTime() > (new Date()).getTime() ? 'active' : 'expired';
                        console.log("status", el.status)

                        return el;
                    }) 
                }
                try {
                    if (this.formData.id) {
                        //update application access
                        await this.$store.dispatch(
                            'updateDataSegment',
                            this.formData
                        )
                    } else {
                        //add application access
                        await this.$store.dispatch(
                            'addDataSegment',
                            this.formData
                        )
                        // Clear form fields
                    }
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method

        async addOption() {
            const result = await this.$validator.validateAll()

            if (result) {
                if(!this.formData.packageDetails.find(el => el.isPrimary)) {
                    this.$store.commit(
                        'setError',
                         'Primary subscription is required to add another subscription or Pro Rata'
                    )
                }
                this.formData.packageDetails.push({
                    salesLead: null,
                    subscriptionDate: null,
                    subscriptionMonth: null,
                    additionalProfiles: null,
                    paymentMethod: null,
                    dealType: null,
                    packageId: null,
                    isPrimary: false,
                })
            } else {
                this.$store.commit(
                    'setError',
                    this.errors.all()[0].replace(/[0-9]/g, '')
                )
            }
        },
        deleteRow(index) {
            let pkg = this.formData.packageDetails[index]
            if(pkg && pkg.stripeTransaction) {
                this.$store.commit(
                    'setError',
                    'Stripe subscription details cannot be removed'
                )
                return 
            }
            this.formData.packageDetails.splice(index, 1)
        },
        handleDateInput(event) {
            // Parse the input date and format it as DD-MM-YYYY
            event = this.formatDate(event)
        },
        formatDate(date) {
            // Parse the input date and format it as DD-MM-YYYY
            return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
        },
    },
}
</script>
<style>
.scrollable.more-fields-popup {
    padding: 3% !important;
}
.removed-row-class {
    top: 0px !important;
    right: 0px !important;
}
.addMoreIcon {
    background: var(--primary-color);
    color: white;
    padding-right: 7px;
    padding-left: 7px;
    cursor: pointer;
    float: right;
}
.mx-datepicker-popup {
    top: 40px !important;
}
</style>
